import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

// Attach admin bearer token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dv_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setAdminToken = (t) => {
  if (t) localStorage.setItem("dv_admin_token", t);
  else localStorage.removeItem("dv_admin_token");
};

export const getAdminToken = () => localStorage.getItem("dv_admin_token");

export const useSeo = (title, description, opts = {}) => {
  if (typeof document === "undefined") return;

  const {
    keywords,
    image,
    type = "website",
    canonical,
  } = opts;

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const url = canonical || `${origin}${path}`;

  if (title) document.title = title;

  const setMeta = (attr, name, content) => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  const setLink = (rel, href) => {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", rel);
      document.head.appendChild(el);
    }
    el.setAttribute("href", href);
  };

  setMeta("name", "description", description);
  setMeta("name", "keywords", keywords);
  setLink("canonical", url);

  // Open Graph
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("property", "og:type", type);
  setMeta("property", "og:site_name", "SharePromos");
  if (image) setMeta("property", "og:image", image);

  // Twitter
  setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  if (image) setMeta("name", "twitter:image", image);
};
